import { PageContentWrapper } from "../../shared/styled/PageContentStyle";
import MaterialListTabNavigations from "./MaterialListTabNavigations";
import Title from "./Title";

const MaterialList = () => {
    return (
        <PageContentWrapper>
            <Title />
            <MaterialListTabNavigations />
        </PageContentWrapper>
    );
};

export default MaterialList;
